import type { FaireProductEntity } from "../../entity_types/product";

export const p_4akzcss44h: FaireProductEntity = {
  token: "p_4akzcss44h",
  type: "product",
  name: "Black Lace Bodysuit V Neck Long Sleeve Sexy Top",
  brandToken: "b_axnmezu6gc",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9259706027a7fa73f894d4a92fecbc4b68b6cedc73f2695842698419264f4313.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a57af593627fb03c6425c1cbf845e56a068b03a312e645df7ce7848c585fbe04.jpeg",
    "https://cdn.faire.com/fastly/661a443dac27f961ee8884f4b4b6800f0f8c4a5ec57a67e922aeb922c88f9ae9.jpeg",
    "https://cdn.faire.com/fastly/0954edee7d96f16d88baab14a75aa67f7ed37ddd0918a0917ec40c8f47dc63f2.jpeg",
    "https://cdn.faire.com/fastly/003e8f9d3a8eaa9f5434e548c3dd6c01e94fd0dade8b61855f48deb3cde995be.jpeg",
    "https://cdn.faire.com/fastly/c1caf848cd530bc3c4861c0d47dae271c06b23c49942eec3a764068dc984e389.jpeg",
    "https://cdn.faire.com/fastly/73c400afadc8c3f2b35df4b958783523677dd6f2d001bf1fb8c0a51750816bba.jpeg",
    "https://cdn.faire.com/fastly/6ec08d81d744aefc9259322a2c376cfe44ed648d7f1bc7a51977e1acc0f3f4a2.jpeg",
    "https://cdn.faire.com/fastly/94765fda0c11c7f556163738cb93a44dd02cd8d9d2708f95490da240d69fd980.jpeg",
    "https://cdn.faire.com/fastly/f03593a0780979c290234c3ade5048e1b9e3ca5b4a4362200b3bc167ef7a4152.jpeg",
    "https://cdn.faire.com/fastly/63b476791d3a4d0801883c0ec868dbaf24325d159bfc136903d87cf0d9774995.png",
  ],
  priceDollars: 16.49,
  description:
    "Elegant Sexy Lace Design\n This black lace bodysuit features intricate floral lace detailing that blends elegance with a bold, feminine edge. A perfect statement piece for boutique buyers targeting elevated going-out and nightwear styles.\n\n Flattering V Neck Silhouette\n Designed with a deep V neckline, this bodysuit enhances the neckline while creating a slimming and sophisticated look that aligns with current fashion trends.\n\n Sheer Lace with Fitted Structure\n The semi-sheer lace fabric combined with a structured fit contours the body beautifully, offering both comfort and a flattering silhouette for various body types.\n\n Long Sleeve with Delicate Detailing\n Featuring long lace sleeves with scalloped edges, this piece adds a romantic and refined touch, making it suitable for both casual chic and dressy occasions.\n\n Versatile Day to Night Styling\n Perfect for pairing with jeans, skirts, or tailored pants. Ideal for date nights, parties, or layering under blazers, making it a high-conversion item for modern boutique assortments.\n\n Brand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_mbyt838sy8 ",
  tags: [],
  msrpDollars: 32.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:24.270Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
